import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../../layout/AuthLayout/authLayout.css";
import CallUsComponet from "../../components/callUs";

export default function HelpSupport() {
  return (
    <>
      <div className="" style={{ height: "inherit" }}>
        <div className="auth-card ">
          <PerfectScrollbar>
            <div className="p-4" align="center">
              <h3 align="center" className="password-text mb-4">
                Customer Enquiry
              </h3>
              <CallUsComponet />
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
}
